// A view is worth reporting only when we have a name for the page and know who
// is looking.
//
// A falsy name is how a route that renders more than one page opts out of the
// ones it has no name for. An unidentified visitor is dropped because the backend
// accepts an identity from a caller who is not signed in for a couple of approved
// event names only, and this is not one of them, so the view would be discarded
// without complaint.
//
export default function shouldReportView({ trackingName, user }) {
  if ( !trackingName ) {
    return false
  }

  return ( Boolean(user.id) && !user.guest )
}
